<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .license-chips {
    display: flex;
    gap: utils.in_rem(8px);
  }
</style>

<script>
  //@ts-check

  /**
   * @typedef {Object} Props
   * @property {import("svelte").Snippet} [children]
   * @property {string} [style]
   */

  /* @type {Props} */
  let { children, style = "" } = $props();
</script>

<div class="license-chips" {style}>
  {@render children?.()}
</div>
